/**
 * The browser entry point.
 *
 * One import of `@catalog/ui/styles.css`, at the root, and it is not optional: Vite's library
 * mode extracts the design system's CSS into a separate file and leaves no import to it in the
 * emitted JavaScript, so nothing inside the package can pull it in on its own. Without this line
 * every `var(--ex-*)` resolves to nothing and the whole app renders unstyled.
 */
import '@catalog/ui/styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App, createQueryClient } from './App.js';
import { createRouter } from './router.js';

const container = document.getElementById('root');
if (container === null) throw new Error('No #root element in index.html.');

// StrictMode on purpose. Its double-invoked effects are what surface an effect that only works
// the first time it mounts — a focus trap, a live region, a subscription that forgets to clean up.
createRoot(container).render(
  <StrictMode>
    <App queryClient={createQueryClient()} router={createRouter()} />
  </StrictMode>,
);
